import { validateAndBuildForwardOption } from "@datadog/browser-logs/cjs/domain/configuration";
import React from "react";

interface StatCardProps {
  icon: string;
  label: string;
  value: number | null | undefined;
  isLoading: boolean;
  showCard: boolean;
  unit?: string;
  round?: boolean;
  decimalPlaces?: number;
  formatCompact?: boolean; 
}

const StatCard: React.FC<StatCardProps> = ({
  icon,
  label,
  value,
  isLoading,
  showCard,
  unit,
}) => {
  if (!showCard) return null;

  const formatValue = (
    value: number | string,
    round?: boolean,
    decimalPlaces?: number
  ): number => {
    const num = Number(value);
    if (isNaN(num)) return 0;

    if (round) return Math.round(num);
    if (decimalPlaces != null) return Number(num.toFixed(decimalPlaces));

    return num;
  };


  const getFormattedParts = (
    val: number | null | undefined,
    round = false,
    decimalPlaces = 2
  ): { numberPart: string; suffixPart?: string } => {
    if (val == null) return { numberPart: "0" };
  
    const absVal = Math.abs(val);
    let numberPart = "";
    let suffixPart = "";
  
    const formatCompact = (num: number): string => {
      const fixed = num.toFixed(decimalPlaces);
      return fixed.endsWith(".0") ? parseInt(fixed).toString() : fixed;
    };
  
    if (absVal >= 1e9) {
      numberPart = formatCompact(absVal / 1e9);
      suffixPart = "B";
    } else if (absVal >= 1e6) {
      numberPart = formatCompact(absVal / 1e6);
      suffixPart = "M";
    } else if (absVal >= 1e3) {
      numberPart = formatCompact(absVal / 1e3);
      suffixPart = "K";
    } else {
      const intPart = Math.floor(absVal);
      if (intPart === 0 && absVal !== 0) {
        numberPart = absVal.toFixed(decimalPlaces);
      } else {
        numberPart = intPart.toString();
      }
    }
  
    if (val < 0) {
      numberPart = `-${numberPart}`;
    }
  
    return { numberPart, suffixPart };
  };
   const { numberPart, suffixPart } = getFormattedParts(value);

  return (
    <div className="bg-white p-0 sm:p-0 rounded-lg shadow-md relative mt-6 border min-h-[200px] flex flex-col justify-between">
      <img
        src={icon}
        alt={`${label} Icon`}
        className="absolute top-4 right-5 w-6 h-6 sm:w-8 sm:h-8 md:w-10 md:h-10"
      />
      <div className="text-center pt-8 sm:pt-12 mt-6 sm:mt-8 min-h-[100px] flex items-center justify-center">
        {isLoading ? (
          <span className="text-xl font-medium text-gray-700">Loading...</span>
        ) : (
          <h2 className="font-poppins font-semibold text-center px-2 text-[clamp(1rem,3vw,2.2rem)] leading-tight max-w-full whitespace-nowrap overflow-visible">
  <span>{numberPart}</span>
  {suffixPart && (
    <span className="text-[clamp(1rem,3vw,1.5rem)] ml-1 ">{suffixPart}</span>
  )}
  {unit && (
    <span className="text-[clamp(0.8rem,2.5vw,1.2rem)} ml-1 px-1">{unit}</span>
  )}
 
</h2>
        )}
      </div>
      <div className=" bg-[#e3e5f2] p-2">
        <p className="text-xs sm:text-base text-gray-700 font-poppins text-center font-semibold">
          {label}
        </p>
      </div>
    </div>
  );
};

export default StatCard;
